/**
 * Sliding puzzle completion scores — mirrors puzzle-be `app.puzzle-coins.sliding`
 * (see application.yml). First completion awards these as puzzle coins / score.
 */
const SLIDING_SCORE_BY_GRID = {
    4: { easy: 1, medium: 2, hard: 3 },
    6: { easy: 2, medium: 4, hard: 6 },
};

/**
 * @param {number} gridSize
 * @param {string} difficulty
 * @returns {number}
 */
export function resolveSlidingPuzzleScore(gridSize, difficulty) {
    const byDiff = SLIDING_SCORE_BY_GRID[Number(gridSize)];
    if (!byDiff) return 0;
    const key = String(difficulty || "")
        .trim()
        .toLowerCase();
    const n = Number(byDiff[key]);
    return Number.isFinite(n) && n > 0 ? n : 0;
}
